module.exports = __webpack_public_path__ + "img/1.8614bd9d.jpg";